import AbstractRequestTask from "../AbstractRequestTask";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import {dymamicHost} from '../../../utils/Utils';

class CheckNetworkStatusTask extends AbstractRequestTask {
  constructor(params ={}) {
    super();
    this.method = params.method;
    this.setStatusCode304As200 = true;
  }
  getMethod(){
    if (this.method) return this.method;
    return 'HEAD';
  }

  getUrl() {
    const host = dymamicHost();
    return `${host}${settings.check_online_url}`;
  }

  isValid(){ // the Request is a HEAD so data must be empty
    return true;
  }

  getStatusCode400As200(){
    return false;
  }

  success(data, b) {
    this.resolve(data);
  }

  getParams() {
    return {};
  }

  getShowModal(){
    // En playing, player lanza/controla modal al perder red
    if(window.location.href.indexOf('/player/') !== -1) {
      return false;
    }
    else {
      return false;
    }
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }

}

export default CheckNetworkStatusTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/CheckNetworkStatusTask.js